import * as storeActions from '@catcore/actions/features';
import {ActionWithPayload, CurrentFeatureState, FeaturePayload} from '@catcore/types/base';

const initialState: CurrentFeatureState = {
  created: null,
  deleted: null
};

export function featureReducer(state: CurrentFeatureState = initialState,
                               action: ActionWithPayload<FeaturePayload>) {
  let returnable = state;

  switch (action.type) {
    case storeActions.CORE_FEATURE_CREATED:
      returnable = {...state, created: action.payload.feature};
      break;
    case storeActions.CORE_FEATURE_DELETED:
      returnable = {...state, deleted: action.payload.feature};
      break;
  }

  return returnable;
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/reducers/feature.reducer.ts